/* ===== SSS Flash Deal price highlight | products in the 'flash-deal' collection get a highlighted price and a promo card (timer + low-stock + stock bar) under the price ===== */
(function(){
  var FD='flash-deal';
  var m=location.pathname.match(/\/products\/([^\/?#]+)/);
  if(!m) return;
  var handle=m[1];
  var ROOT_SEL='[data-section-type="main-product-invi"]';

  function go(){
    fetch('/collections/'+FD+'/products.json?limit=250',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():{products:[]};})
      .then(function(d){
        if((d.products||[]).some(function(p){return p.handle===handle;})) waitFor(ROOT_SEL+' [data-mp-price]', sssFlashInit);
      })
      .catch(function(){});
  }
  if(document.readyState!=='loading') go(); else document.addEventListener('DOMContentLoaded', go);

  function waitFor(sel,cb,n){ n=n||0; var el=document.querySelector(sel); if(el) return cb(el); if(n>40) return; setTimeout(function(){waitFor(sel,cb,n+1);},150); }

  function sssFlashInit(box){
    if(!box.classList.contains('sss-flash-price')) box.classList.add('sss-flash-price');
    if(document.querySelector('.sss-flash-card')) return;

    var card=document.createElement('div'); card.className='sss-flash-card';
    card.innerHTML =
      '<div class="sss-fc-top">'+
        '<div class="sss-fc-left">'+
          '<span class="sss-fc-badge">Flash Deal</span>'+
          '<span class="sss-fc-endsoon">Ends soon!</span>'+
        '</div>'+
        '<span class="sss-fc-stock" hidden>&#128293; Only <b data-fd-qty>0</b> left at this price!</span>'+
      '</div>'+
      '<div class="sss-fc-timerow">'+
        '<span class="sss-fc-timelabel">Time remaining:</span>'+
        '<span class="sss-fc-clock">'+
          '<span class="sss-fc-seg"><b data-fd-d>00</b></span><span class="sss-fc-colon">:</span>'+
          '<span class="sss-fc-seg"><b data-fd-h>00</b></span><span class="sss-fc-colon">:</span>'+
          '<span class="sss-fc-seg"><b data-fd-m>00</b></span><span class="sss-fc-colon">:</span>'+
          '<span class="sss-fc-seg sss-fc-seg--sec"><b data-fd-s>00</b></span>'+
        '</span>'+
      '</div>'+
      '<div class="sss-fc-progress"><div class="sss-fc-progress-fill" data-fd-fill></div></div>';

    // Insert under the whole price row (price + stock row + shipping note), not inside its inner wrapper
    var row=box.closest('[data-mp-price-row]')||box;
    row.parentNode.insertBefore(card, row.nextSibling);

    sssFlashTimer(card);
    sssFlashStock(card, row);
  }

  function sssFlashTimer(root){
    function nextEnd(){var n=new Date(),d=new Date(n),add=(1-d.getDay()+7)%7;d.setDate(d.getDate()+add);d.setHours(9,0,0,0);if(d<=n)d.setDate(d.getDate()+7);return d;}
    var target=nextEnd();function p(n){return(n<10?'0':'')+n;}
    function tick(){var df=Math.max(0,target-new Date()),s=Math.floor(df/1000);
      root.querySelector('[data-fd-d]').textContent=p(Math.floor(s/86400));
      root.querySelector('[data-fd-h]').textContent=p(Math.floor(s%86400/3600));
      root.querySelector('[data-fd-m]').textContent=p(Math.floor(s%3600/60));
      root.querySelector('[data-fd-s]').textContent=p(s%60);
      if(df<=0){target=nextEnd();}}
    tick();setInterval(tick,1000);
  }

  /* Stock comes from the Liquid-rendered [data-mp-inventory] JSON (variant id -> qty, -1 = untracked)
     and the threshold from data-flash-min on the price row. Re-renders on the
     'mp:variant-change' event fired by the section's updateUI(). */
  function sssFlashStock(card, row){
    var fill=card.querySelector('[data-fd-fill]');
    var stockEl=card.querySelector('.sss-fc-stock');
    var min=parseInt(row.getAttribute('data-flash-min'),10);
    var invEl=document.querySelector(ROOT_SEL+' [data-mp-inventory]');
    var inv={};
    try{ inv=JSON.parse(invEl.textContent); }catch(e){}

    function render(variantId){
      var qty=parseInt(inv[variantId],10);
      if(isNaN(qty) || qty<0 || isNaN(min) || min<=0){ // untracked / unknown
        stockEl.hidden=true; if(fill) fill.style.width='15%'; return;
      }
      if(qty>0 && qty<=min){
        stockEl.hidden=false;
        stockEl.querySelector('[data-fd-qty]').textContent=qty;
        var pct=Math.max(4,Math.min(100,Math.round((qty/min)*100)));
        if(fill) fill.style.width=pct+'%';
      } else {
        stockEl.hidden=true;
        if(fill) fill.style.width='100%';
      }
    }

    var idInput=document.querySelector(ROOT_SEL+' [data-mp-selected-variant-id]');
    render(idInput ? idInput.value : null);
    document.addEventListener('mp:variant-change', function(e){
      if(e.detail && e.detail.variant) render(e.detail.variant.id);
    });
  }
})();